const VALID_MIGRATION_STATUSES = new Set(["pre-live", "live", "complete"]);

export function getMigrationStatus() {
  const rawStatus = process.env.REACT_APP_MIGRATION_STATUS;
  const fallbackStatus = process.env.REACT_APP_MAINTENANCE_MODE === "true" ? "pre-live" : "complete";
  const status = rawStatus || fallbackStatus;

  return VALID_MIGRATION_STATUSES.has(status) ? status : fallbackStatus;
}

export function getLegacySiteUrl() {
  return process.env.REACT_APP_LEGACY_SITE_URL || "";
}
